import '../css/index.scss';
import WeixinShare from './weixin';
import report from './report';

const CONFIG = {
    sy: {
        android: 'http://rel.huya.com/apk/zs?key=syandroid',
        ios: 'http://hydownload.huya.com',
    },
    zs: {
        android: 'http://rel.huya.com/apk/zs?key=zsandroid',
        ios: 'http://rel.huya.com/apk/zs?key=zsios',
    }

}

const fn = {
    init() {
        
        report({
            eid:'pv/livetutorial',
            eid_desc:'pv/直播指引',
        });
        const $mask = $('.mask');
        // 微信环境分享初始化
        if(this.isWeixin()) {
            const shareData = {
                title: '成为虎牙主播', // 分享标题
                desc: '下载开播工具，1分钟开启直播', // 分享描述
                link: location.href, // 分享链接
                imgUrl: 'https://zt.msstatic.com/zt/img/18/09/05/153614204875350020297.png', // 分享图标
            }
            new WeixinShare(shareData, false);
        }
        $('#zs').on('click', () => {
            report({
                eid:'pv/livetutorial/zsdownload',
                eid_desc:'点击/直播指引/下载虎牙助手',
            })
            let url = '';
            if(this.isWeixin()) {
                $mask.show();
                return;
            }
            if (this.isAndroid()) {
                document.title = '虎牙助手下载';
                url = CONFIG.zs.android;
            } else if(this.isiOS()) {
                url = CONFIG.zs.ios;
            }
            setTimeout(()=>{
                location.href = url;
            }, 100)
        });
        $('#sy').on('click', () => {
            report({
                eid:'pv/livetutorial/sydownload',
                eid_desc:'点击/直播指引/下载虎牙手游',
            })
            let url = '';
            if(this.isWeixin()) {
                $mask.show();
                return;
            }
            console.log(this.isAndroid());
            if (this.isAndroid()) {
                url = CONFIG.sy.android;
            } else if(this.isiOS()) {
                url = CONFIG.sy.ios;
            }
            setTimeout(()=>{
                location.href = url;
            }, 100)
        });
        $mask.on('click', function() {
            $(this).hide();
        })
        
    },
    isWeixin() { //判断是否是微信
        return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
    },
    isAndroid() {
        return navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1
    },
    isiOS() {
        return !!/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    }
};
fn.init();